export function observePageScroll(
    onIntersect: (navigationItemId: string) => void, // eslint-disable-line no-unused-vars
) {
    const options = {
        root: null,
        rootMargin: '70px',
        threshold: 1.0,
    };

    const observer = new IntersectionObserver((entries) => {
        entries
            .filter((e) => e.isIntersecting)
            .forEach((entry) => {
                const { target } = entry;
                const isDish = target.hasAttribute('data-id');
                const navigationItemId = isDish
                    ? target.getAttribute('data-id')
                    : target.getAttribute('data-category-title-id');

                if (navigationItemId) {
                    onIntersect(navigationItemId);
                }
            });
    }, options);

    const categories = document.querySelectorAll('[data-category-title-id]');
    const dishes = document.querySelectorAll('[data-id]');

    categories.forEach((category) => {
        observer.observe(category);
    });
    dishes.forEach((dish) => {
        observer.observe(dish);
    });

    return observer;
}
